import React from "react";
import Button, { ButtonColorTypes } from "./Button";

export interface ExtensionInstallBannerProps {
  title: string;
  description: string;
  actionLabel: string;
  /** Click handler */
  onClick?: () => void;
}

function ExtensionInstallBanner({
  title,
  description,
  actionLabel,
  onClick,
}: ExtensionInstallBannerProps) {
  return (
    <div className="mb-4 flex items-center justify-between rounded-md border border-amber-200 bg-amber-50 px-4 py-3">
      <div>
        <p className="text-sm font-semibold text-amber-900">{title}</p>
        <p className="text-sm text-amber-800">{description}</p>
      </div>
      <Button
        text={actionLabel}
        colorType={ButtonColorTypes.primary}
        className="text-sm"
        onClick={onClick}
        disabled={!onClick}
      />
    </div>
  );
}

export default ExtensionInstallBanner;
